module.exports = __webpack_public_path__ + "static/media/Surrounding4.e153effe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding4.jpeg
// module id = 577
// module chunks = 0